import {Component, Inject, OnInit} from "@angular/core";
import {AlertService, AuthenticationService, ProjectService} from "../../_services";
import {Router} from "@angular/router";
import {LoginHelper, Recurring, StringsHelper} from "../../helpers";
import {ProjectControlItem, User} from "../../_models";
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

@Component({
    standalone: false,
  selector: "select-single-project-control-item",
  templateUrl: 'select-single-project-control-item.component.html',
  styleUrls: ['./select-single-project-control-item.component.scss'],
})
export class SelectSingleProjectControlItemComponent implements OnInit {
  projectControlItems: ProjectControlItem[] = [];
  currentUser: User;
  recurringList: any;
  projectId: number;
  excludeProjectControlItemId: number;
  subVisible = {};

  cols : any[] = [
    {'field': 'controlItem.complianceAreaControlId', 'header': 'Control ID'},
    {'field': 'controlItem.category', 'header': 'Category'},
    {'field': 'controlItem.description', 'header': 'Description'},
    {'field': 'assignedClient.userId', 'header': 'Control Owner'},
    {'field': 'recurring', 'header': 'Recurring'},
    {'field': 'dueDate', 'header': 'Due Date'},
  ]

  rowGroupMetadata = {};


  constructor(
    public projectService: ProjectService,
    public router: Router,
    public authenticationService: AuthenticationService,
    public alertService: AlertService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<SelectSingleProjectControlItemComponent>) {
    this.projectId = data.projectId;
    this.excludeProjectControlItemId = data.excludeProjectControlItemId;
  }

  ngOnInit() {
      const tenantName = LoginHelper.getTenantName();
      if (tenantName == null || LoginHelper.getUserToken() == null) {
      this.authenticationService.logout();

      return;
    }
    this.recurringList = [];
    for (let i=0; i <= Recurring.Yearly; i++) {

      this.recurringList[i] = Recurring[i].toString();
    }

    this.currentUser = JSON.parse(sessionStorage.getItem('currentUser'));

    this.projectService.getById(this.projectId).subscribe(
      data => {
        //this.projectControlItems = this.projectControlItems.sort((a, b) => a.controlItem.category > b.controlItem.category ? 1 : -1);

        this.projectControlItems = data.projectControlItems.filter(i => i.projectControlItemId != this.excludeProjectControlItemId && !data.projectControlItems.find(l => l.controlItemId == i.controlItem.parentControlItemId));
        this.projectControlItems.forEach(projectControlItem => {
          let i;
          projectControlItem.subItems = data.projectControlItems.filter(i => i.controlItem.parentControlItemId == projectControlItem.controlItem.controlItemId)
            .sort((a, b) => a.controlItem.level > b.controlItem.level ? 1 : a.controlItem.level < b.controlItem.level ? -1 :
              a.controlItem.complianceAreaControlId > b.controlItem.complianceAreaControlId ? 1 : -1);
          projectControlItem.subItemLevels = [];
            let currentLevel = "";
            for (i = 0; i < projectControlItem.subItems.length; i++)
          {
            projectControlItem.subItems[i].hasParent = true;
            if (projectControlItem.subItems[i].controlItem.level != currentLevel)
            {
              currentLevel = projectControlItem.subItems[i].controlItem.level;
                const newSubItemLevel = {subItems: [], level: currentLevel};
                projectControlItem.subItemLevels.push(newSubItemLevel);
            }
            projectControlItem.subItemLevels[projectControlItem.subItemLevels.length - 1].subItems.push(projectControlItem.subItems[i]);
          }
        });

        console.log(this.projectControlItems);
        this.updateRowGroupMetaData();
        console.log(this.rowGroupMetadata);
      });

  }

  getFullName(user: User){

    return StringsHelper.getFullName(user);
  }

  selectProjectControlItem(data)
  {
    this.dialogRef.close(data);
  }
  updateRowGroupMetaData() {
      const data = this.projectControlItems;
      this.rowGroupMetadata = {};
    if (data) {
      for (let i = 0; i < data.length; i++) {
        let rowData = data[i];
        let brand = rowData.controlItem.category;
        if (i == 0) {
          this.rowGroupMetadata[brand] = { index: 0, size: 1 };
        }
        else {
          let previousRowData = data[i - 1];
          let previousRowGroup = previousRowData.controlItem.category;
          if (brand === previousRowGroup)
            this.rowGroupMetadata[brand].size++;
          else
            this.rowGroupMetadata[brand] = { index: i, size: 1 };
        }
      }
    }

  }
}
